JACADI.session = {

	_autoload : [ 'fillCSRFToken' ],

	init : function() {
		if (JACADI.session._token) {
			return JACADI.session._token;
		} else {
			return JACADI.session.getSessionToken();
		}
	},

	getSessionToken : function() {
		JACADI.session._token = $.Deferred();
		$.ajax({
			url : JACADI.AJAX.csrf,
			cache : false,
			async: false,
			type : 'GET',
			dataType : 'json',
			success : function(jsonData) {
				JACADI.session._token.resolve(jsonData);
				JACADI.session.setBrowserInfos();
			},
			fail : function(jqXHR, status) {
				console.error('Can t init session');
			}
		});
		return JACADI.session._token;
	},

	fillCSRFToken : function() {
		if (!Boolean(JACADI.isInCheckout)) {
			JACADI.session.init().done(function(tokenData) {
				// Quick fix for R31 HotFix
				// Need to review POST Call with new JS
				ACC.config.CSRFToken=tokenData.tokenValue;
			});
			$('input[name="CSRFToken"').each(function() {
				var $that = $(this);
				JACADI.session.init().done(function(tokenData) {
					$that.attr('value', tokenData.tokenValue);
				});
			});

		}
	},

	setBrowserInfos : function() {
		browserInfo = {
			browserAcceptHeader : "",
			browserColorDepth : screen.colorDepth,
			browserJavaEnabled : navigator.javaEnabled(),
			browserScreenHeight : screen.height,
			browserScreenWidth : screen.width,
			browserLanguage: navigator.language,
			browserTimeZone : new Date().getTimezoneOffset(),
			browserUserAgent : navigator.userAgent,
		}

		$.ajax({
			headers: {"CSRFToken": window.ACC.config.CSRFToken},
			url:  JACADI.AJAX.browserInfos,
			cache: false,
			type: 'POST',
			contentType:"application/json; charset=utf-8",
			dataType : 'json',
			data: JSON.stringify(browserInfo),
			success: function(){
			}
		});
	}
};
